import { useLayoutEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setactiveItem } from "store/cards";
import { useSoundPath } from "hooks/useSoundPath";
import { createAPI } from "services/api/api";
import useProfile from "hooks/useProfile";

import OpenPackVideo from "components/open-pack/OpenPackVideo";
import CardPacksEmpty from "components/placeholder-blocks/CardPacksEmpty";
import CommonItemInfo from "components/common-item/CommonItemInfo";
import OpenPackAudio from "components/open-pack/OpenPackAudio";
import useActiveItem from "hooks/useActiveItem";
import MainContentLeft from "components/main-components/MainContentLeft";

const CardPacksOpen = () => {
  const api = createAPI();
  const dispatch = useDispatch();
  const { token, isMobile } = useProfile();
  const { activeItem } = useActiveItem();
  const [isLoading, setIsLoading] = useState(true);
  const [isVideoVisible, setIsVideoVisible] = useState(true);
  const [cards, setCards] = useState([]);
  const playSound = useSoundPath();
  const [animation, setAnimation] = useState({
    web: null,
    mobile: null,
  });
  const { id } = useParams();
  const cardRef = useRef(null);

  const getOpenedClass = () => {
    if (activeItem) {
      return "opened";
    } else if (cards === null) {
      return "";
    }
  };

  const addAllRevealedClass = () =>
    cards.every((card) => card.isRevealed === true)
      ? "cards-list__block--revealed"
      : "";

  const getImage = (img) => {
    if (!img || img === "") {
      return "https://placehold.co/147x247";
    } else return img;
  };

  const revealCard = (card) => {
    setCards((prevCards) =>
      prevCards.map((item) =>
        item.id === card.id ? { ...item, isRevealed: true } : item
      )
    );
    playSound("cardReveal");
  };

  const revealAllCards = () => {
    playSound("main");
    const totalCards = cards.length;
    let revealedCount = 0;

    const intervalId = setInterval(() => {
      setCards((prevCards) => {
        const updatedCards = [...prevCards];

        while (
          revealedCount < totalCards &&
          updatedCards[revealedCount].isRevealed
        ) {
          revealedCount++;
        }

        if (revealedCount < totalCards) {
          updatedCards[revealedCount].isRevealed = true;
          playSound("cardReveal");


          const currentCardIndex = revealedCount + 1;

          if (currentCardIndex % 6 === 0 || currentCardIndex === totalCards) {
            setTimeout(() => {
              const revealedItems = Array.from(
                document.querySelectorAll(".cards-list__block-item--revealed")
              );

              if (revealedItems.length > 0) {
                const lastRevealedItem =
                  revealedItems[revealedItems.length - 1];


                lastRevealedItem.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }, 100);
          }

          revealedCount++;
        } else {
          clearInterval(intervalId);
        }

        return updatedCards;
      });
    }, 300);
  };

  useLayoutEffect(() => {
    if (isLoading === true && token) {
      api
        .post(`/card_pack/${id}/open`)
        .then((response) => {
          const newCards = response.data.data.map((card, index) => ({
            ...card,
            id: index,
            isRevealed: false,
            tag: "",
          }));
          setCards(newCards);
          setAnimation({
            web: response.data.web_animation,
            mobile: response.data.mobile_animation,
          });
          setIsLoading(false);
        })
        .catch((error) => console.log(error));
    }
  }, []);

  if (cards) {
    return (
      <>
        <OpenPackVideo
          isVideoVisible={isVideoVisible}
          setIsVideoVisible={setIsVideoVisible}
          animation={animation}
          isMobile={isMobile}
        />
        <main
          className={`main-content ${
            isVideoVisible === false ? "main-content--video-closed" : ""
          }`}
        >
          <MainContentLeft getOpenedClass={getOpenedClass} filters={null} />
          <div className="main-content__right">
            {!cards.length ? (
              <CardPacksEmpty />
            ) : (
              <div className="cards-list">
                <header className="cards-list__header">
                  <h2 className="cards-list__title">
                    Cards
                    <span>{cards.length}</span>
                    <i className="cards-list__title-help">
                      Click cards to reveal
                    </i>
                  </h2>

                  {cards.every((card) => card.isRevealed === true) ? (
                    <Link
                      className="cards-list__header-link"
                      to="/inventory/card-packs"
                      onClick={() => playSound("nav")}
                    >
                      Back to Card Packs
                    </Link>
                  ) : (
                    <button
                      className="cards-list__header-button"
                      onClick={revealAllCards}
                    >
                      Reveal All
                    </button>
                  )}
                </header>
                {isLoading === false && (
                  <ul
                    className={`cards-list__block cards-list__block--min ${addAllRevealedClass()}`}
                  >
                    {cards.map((card) => (
                      <li
                        key={card.id}
                        ref={cardRef}
                        onClick={() => {
                          revealCard(card);
                          dispatch(setactiveItem(card));
                        }}
                        className={`cards-list__block-item ${
                          card.isRevealed
                            ? "cards-list__block-item--revealed"
                            : ""
                        } ${
                          activeItem && activeItem.id === card.id
                            ? "active"
                            : ""
                        }`}
                      >
                        <div className="cards-list__block-item-pic-to-open">
                          <img
                            src={getImage(card.image_back)}
                            className="cards-list__block-item-pic"
                            alt=""
                          />
                          <CommonItemInfo
                            additionalClass={
                              "cards-list__block-item-pic--detail"
                            }
                            type={card.type}
                            image={card.image}
                            name={card.name}
                            props={card.properties}
                          />
                        </div>
                        <p className="cards-list__block-item-text">
                          {card.type.toLowerCase() === "prize"
                            ? "$" + card.name
                            : card.name}
                        </p>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
          {/* <OpenPackAudio /> */}
        </main>
      </>
    );
  }
};

export default CardPacksOpen;
